import { Stack, Box, Heading, Text } from "@chakra-ui/react";
import { IconSquare } from "./IconSquare";
import { IconToolTip } from "./IconToolTip";
import theme from "../Theme/theme";

export const ThreeColumnStatisticBlockLargeText = ({
  children,
  icon,
  tooltipLabel,
  heading,
  iconBackgroundColor,
  textColor,
}) => {
  return (
    <Stack
      w="100%"
      spacing={0}
      direction="row"
      align="center"
      justifyContent="space-around"
      bg={{
        base: `linear-gradient(to right, #2C3236, ${theme.colors.secondaryBackgroundColor}, #2C3236)`,
      }}
      borderRadius={12}
      py={3}
    >
      <Box>{<IconSquare bgColor={iconBackgroundColor} icon={icon} />}</Box>
      <Stack
        w="50%"
        alignSelf="flex-start"
        justifySelf="center"
        mx="auto"
        py={1.5}
      >
        <Heading size={{ base: "sm", "2xl": "sm" }}>{heading}</Heading>
        <Text
          color={textColor}
          fontWeight="bold"
          fontSize={{ base: "lg", "2xl": "xl" }}
        >
          {children}
        </Text>
      </Stack>
      <IconToolTip label={tooltipLabel} />
    </Stack>
  );
};
